import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import IconDecryptionButton from '../../../assets/icons/decryption-button.svg';
import IconPlayButton from '../../../assets/icons/play-button.svg';
import ThumbnailImg from '../../../assets/images/thumbnail.jpg';
import PlayerComponent from '../../../components/Player';
import * as SERVICE from '../../../constants/service.types';
import { setPlayVideoAtPage, socketEmitEvent } from '../../../redux/actions';
import classes from './VideoPlayer.module.scss';

const PERMISSION = 'live_playback_download'.split('_');

const VideoPlayer = ({ video }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    namespace,
    public_ip: ipAddress,
    decryptData,
    playVideoAtPage,
  } = useSelector((state) => state);

  const [videoSrc, setVideoSrc] = useState('');
  const [isLoadingVideo, setIsLoadingVideo] = useState(false);

  useEffect(() => {
    if (
      decryptData &&
      video.recordId === decryptData.recordId &&
      playVideoAtPage === 'PLAY_VIDEO_IN_SEARCH_MODAL_CAMERA'
    ) {
      setVideoSrc(decryptData.secureLink);
    }
  }, [decryptData, video.recordId, playVideoAtPage]);

  const handleViewVideo = (recordId) => {
    setIsLoadingVideo(true);
    if (recordId) {
      let dataBody = {
        ipAddress: '0.0.0.0',
        recordId,
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.GENERATE_LINK_STORAGE_FILE,
        requestId: new Date().getTime(),
        body: JSON.stringify(dataBody),
      };
      dispatch(setPlayVideoAtPage('PLAY_VIDEO_IN_SEARCH_MODAL_CAMERA'));
      return dispatch(socketEmitEvent(dataObj));
    }
  };

  const handleReportActionLog = (logContent, logSerial) => {
    let data = {
      action: 'Download',
      content: logContent,
      namespace,
      serial: logSerial,
    };
    let dataObj = {
      appServiceType: SERVICE.REPORT_ACTION_LOG,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    dispatch(socketEmitEvent(dataObj));
  };

  return (
    <div className={classes['container']}>
      {!isLoadingVideo && !videoSrc && video.cameraName && (
        <div className={classes['video-player-title']}>{video.cameraName}</div>
      )}

      <PlayerComponent
        type="video"
        loading={isLoadingVideo}
        src={videoSrc}
        fromTime={video?.from}
        toTime={video?.to}
        expectedDuration={video?.duration}
        permission={PERMISSION}
        poster={
          video.thumbnail && video.thumbnail.match(/http/g)
            ? video.thumbnail
            : ThumbnailImg
        }
        logContent={JSON.stringify({
          recordId: video.recordId,
          isSaveAs: decryptData?.fileName ? true : false,
          cameraName:
            decryptData?.fileName || video.fileName?.replace('.mp4', ''),
          actionDate: moment(video.recordDate).format('DD-MM-YYYY'),
        })}
        logSerial={video.serial}
        handleReportActionLog={handleReportActionLog}
      />

      {!isLoadingVideo && !videoSrc && (
        video?.type === 'on_gateway' ||
        (typeof video.recordId === 'string' &&
          video.recordId.startsWith('on_gateway-')) ? (
          <Tooltip title={t('Playing gateway recording is disabled')}>
            <img
              className={classes['icon-play']}
              alt="play-button"
              src={video.encrypt === 'none' ? IconPlayButton : IconDecryptionButton}
              style={{
                cursor: 'not-allowed',
                opacity: 0.35,
                filter: 'grayscale(100%)',
              }}
            />
          </Tooltip>
        ) : (
          <img
            className={classes['icon-play']}
            alt="play-button"
            onClick={() => handleViewVideo(video.recordId)}
            src={video.encrypt === 'none' ? IconPlayButton : IconDecryptionButton}
          />
        )
      )}
    </div>
  );
};

export default VideoPlayer;
